import PropTypes from 'prop-types'
import styled from 'styled-components'
import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'

// we scale down 12px icon as browser may have setting limiting
// lower bound of font size (e.g. > 8px)
const StyledIconLink = styled(IconLink)`
  && {
    padding: 0 2px 0 0;

    &:hover {
      background-color: transparent;
    }

    &:before {
      color: ${colors.secondary40} !important;
      transform: scale(0.5);
    }

    &:hover:before {
      color: ${colors.primary40} !important;
    }
  }
`

const MultiValueRemove = (props) => {
  // innerProps contains onMouseDown and other props
  // we need to use it if we have custom component like IconLink
  const { innerProps } = props

  return (
    <StyledIconLink
      {...innerProps}
      iconName='icon-close-12'
    />
  )
}

MultiValueRemove.propTypes = {
  innerProps: PropTypes.object,
}

export default MultiValueRemove
